<custom-table [config]="customTable"[rowExpansionTemplate]="tableRowexpansion" (emitterLazyLoad)="lazyloadRecords($event)" />
<ng-template #tableRowexpansion let-data >
	<app-tramite-actividades [tramRegistroId]="data.id" [estado]="data.tramEstado" [observaciones]="data.observacion"
                           class="app-card w-11 mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
<app-visor/>
